var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVeloz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.426,
    height: 19.714,
    viewBox: "0 0 13.426 19.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4219",
    "data-name": "Group 4219",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_628",
    "data-name": "Ellipse 628",
    cx: 3.973,
    cy: 3.973,
    rx: 3.973,
    ry: 3.973,
    transform: "translate(1.99 0)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M6,20.963V18.975A3.975,3.975,0,0,1,9.975,15h3.975a3.975,3.975,0,0,1,3.975,3.975v1.988",
    transform: "translate(-6 -2.749)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVeloz);
export default __webpack_public_path__ + "static/media/icon_veloz.782b8636ba36d692d1b50ddea137df77.svg";
export { ForwardRef as ReactComponent };